import React, { useEffect } from "react";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { axiosGet } from "../utils/AxiosUtils";
import Autocomplete from "@mui/material/Autocomplete";
import RefreshIcon from "@mui/icons-material/Refresh";
import { formatLabel } from "../utils/SaitUtils";
import { Box, IconButton, InputAdornment } from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";

export default function SaitCombo(props) {
	const theme = useTheme();

	const defaultSize = "small";

	const [itemsCombo, setItemsCombo] = React.useState([]);
	const [loadingFind, setLoadingFind] = React.useState(false);

	useEffect(() => {
		setItemsForAutocomplete(props.items);
		// eslint-disable-next-line
	}, [JSON.stringify(props.items)]);

	/////// FIND A DB ///////
	useEffect(() => {
		if (props.findParameters && !props.disabled) {
			setLoadingFind(true);
		}
		// eslint-disable-next-line
	}, [JSON.stringify(props.findParameters), props.disabled]);

	useEffect(() => {
		if (loadingFind) {
			getItemsFindFunction();
		}
		// eslint-disable-next-line
	}, [loadingFind]);

	const getItemsFindFunction = async () => {
		const resp = await axiosGet(props.findParameters.findFunction, props.findParameters.findFilters, props.findParameters.orderBy);
		setItemsForAutocomplete(resp.rows);
		setLoadingFind(false);
		if ((props.autoselectFirstRow && resp.rows.length > 0) || (props.autoselectSingleRow && resp.rows.length === 1)) {
			handleOnChange(resp.rows[0]);
		}
	};
	////////////////////////////

	const setItemsForAutocomplete = (items) => {
		let autoCompleteArray = [];
		items?.forEach((item) => {
			let labelDescription = formatLabel(props.description, item);

			item.customOptionLabel = labelDescription;

			autoCompleteArray.push(item);
		});
		setItemsCombo(autoCompleteArray);
	};

	const handleOnChange = (newValue) => {
		props.onChange(newValue);
	};

	const getOptionLabel = (option) => {
		if (option.customOptionLabel) {
			return option.customOptionLabel;
		} else {
			const item = itemsCombo.find((row) => {
				return props.name.every((obj) => {
					return row[obj.comboName] === props.value[obj.storeName];
				});
			});
			return item ? item.customOptionLabel : "";
		}
	};

	const textFieldStyle = {
		"& .MuiOutlinedInput-root.Mui-disabled": {
			backgroundColor: alpha(theme.palette.text.primary, 0.05),
			borderRadius: 1,
		},
		"& .MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input.Mui-disabled": {
			color: theme.palette.text.primary, // colore testo più scuro
			WebkitTextFillColor: theme.palette.text.primary, // forza colore su Chrome/Edge
			opacity: 0.8,
		},
		"& .MuiInputLabel-root.Mui-disabled": {
			color: theme.palette.text.secondary,
		},
	};

	return (
		<Autocomplete
			options={props.findParameters ? ["ReloadComboJsws", ...itemsCombo] : itemsCombo}
			sx={{
				...props.sx,
			}}
			disabled={(!props.findParameters && props.items === null && !props.filterOptions) || loadingFind || props.disabled || props.readOnly}
			value={props.value[props.name[0].storeName] || props.value[props.name[0].storeName] === 0 ? props.value : null}
			onChange={(event, newValue) => handleOnChange(newValue)}
			isOptionEqualToValue={(option, value) => {
				return props.name.every((combo) => option[combo.comboName] === value[combo.storeName]);
			}}
			getOptionLabel={getOptionLabel}
			filterOptions={props.filterOptions}
			onInputChange={props.onInputChange}
			renderInput={(params) =>
				((!props.findParameters && props.items === null) || loadingFind) && !props.disabled && !props.filterOptions ? (
					// Se sto caricando i record da DB metto un textfield con un CircularProgress
					<TextField
						{...params}
						label={props.label}
						size={props.size || defaultSize}
						sx={textFieldStyle}
						slotProps={{
							input: {
								startAdornment: (
									<InputAdornment position="start">
										<CircularProgress size={30} />
									</InputAdornment>
								),
							},
						}}
						disabled={props.disabled || props.readOnly}
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								// autoseleziono l'elemento se ho un solo risultato
								const filtered = (props.filterOptions ? props.filterOptions(itemsCombo, { inputValue: e.target["value"] }) : itemsCombo).filter((opt) => opt !== "ReloadComboJsws");

								if (filtered.length <= 1) {
									e.preventDefault(); // evita submit del form
									if (filtered.length === 1) {
										handleOnChange(filtered[0]);
									}
								}
							}
						}}
					/>
				) : (
					<TextField
						{...params}
						required={props.required}
						label={props.label}
						sx={textFieldStyle}
						error={props.error}
						size={props.size || defaultSize}
						disabled={props.disabled || props.readOnly}
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								// autoseleziono l'elemento se ho un solo risultato
								const filtered = (props.filterOptions ? props.filterOptions(itemsCombo, { inputValue: e.target["value"] }) : itemsCombo).filter((opt) => opt !== "ReloadComboJsws");

								if (filtered.length <= 1) {
									e.preventDefault(); // evita submit del form
									if (filtered.length === 1) {
										handleOnChange(filtered[0]);
									}
								}
							}
						}}
					/>
				)
			}
			renderOption={(renderProps, option, { selected }) => {
				// @ts-ignore
				let { key, limitTags, findParameters, ...restRenderProps } = renderProps;
				if (option === "ReloadComboJsws") {
					return (
						<Box
							key={"RELOAD"}
							component="li"
							{...restRenderProps}
							sx={{
								display: "flex",
								justifyContent: "center !important",
								padding: 0,
							}}
						>
							<IconButton
								size="small"
								onClick={() => {
									setLoadingFind(true);
								}}
							>
								<RefreshIcon />
							</IconButton>
						</Box>
					);
				} else {
					return (
						<li key={key} {...restRenderProps}>
							{/* Multiple non gestito in EditPanel */}
							{/* {props.multiple && <Checkbox icon={<CheckBoxOutlineBlankIcon fontSize="small" />} checkedIcon={<CheckBoxIcon fontSize="small" />} checked={selected} />} */}
							{getOptionLabel(option)}
						</li>
					);
				}
			}}
		/>
	);
}
